<div class="ktbl-spacer-top-bottom"></div>

<span *ngIf="this.localService.selectedGebaeudeList.value.length === 0">
  Sie haben noch kein Gebäude für einen Vergleich ausgewählt.

</span>

<span *ngIf="((localService.selectedGebaeudeList.value?.length ?? 0) > 0 )
        && ((localService.mainComponentRef.value?.spinnerService?.getCountSpinner() ?? 0) === 0 || showEmpty)">

  <table mat-table [dataSource]="dataSourceSelectGebaeude" class="ktbl-table-breite-komplett">

    <ng-container *ngFor="let column of displayedColsSelectGebaeude; let j = index" [matColumnDef]="column">

      <th mat-header-cell *matHeaderCellDef [ngClass]="{
        'ktbl-bezeichnung-width': column.startsWith('BEZEICHNUNG'),
        'ktbl-select-width': column.startsWith('ANZEIGEN'),
        'ktbl-plaene-width': column.startsWith('PLAENE'),
        'ktbl-table-header-base-neutral':
          j !== 0 && j !== (displayedColsSelectGebaeude.length - 1),
        'ktbl-table-header-base-links': j === 0,
        'ktbl-table-header-base-rechts':
          j === (displayedColsSelectGebaeude.length - 1),
        'ktbl-table-header-typografie': true
      }">

        <ng-container *ngIf="column.startsWith('ANZEIGEN')">
          Anzeigen
        </ng-container>

        <ng-container *ngIf="column.startsWith('BEZEICHNUNG')">
          Bezeichnung
        </ng-container>

        <ng-container *ngIf="column.startsWith('GALERIE')">
          Galerie
        </ng-container>

        <ng-container *ngIf="column.startsWith('PLAENE')">
          Pläne
        </ng-container>

      </th>

      <td mat-cell *matCellDef="let entry; let i = index" class="ktbl-table-cell-center ktbl-table-cell-no-padding-left"
        [ngClass]="{
        'ktbl-table-content-normal': i % 2 === 0,
        'ktbl-table-content-invert': i % 2 !== 0,
        'ktbl-table-content-border': j === 0
      }">

        <!-- Anzeigen -->
        <ng-container *ngIf="
          column.startsWith('ANZEIGEN') &&
          entry['gebaeude'] !== undefined
        ">

          <mat-checkbox [checked]="isGebaeudeSelected(entry['gebaeude'])"
            [disabled]="localService.selectedGebaeudeList.value.length <= 1"
            (change)="onClickToggleAnzeigen(entry['gebaeude'])">
          </mat-checkbox>

        </ng-container>

        <!-- Textinhalt -->
        <ng-container *ngFor="let colSuffix of ['BEZEICHNUNG', 'GALERIE', 'PLAENE']">

          <ng-container *ngIf="column.startsWith(colSuffix)">
            {{ entry[colSuffix.toLowerCase()] }}
          </ng-container>

        </ng-container>

        <!-- Galerie -->
        <ng-container *ngIf="
          column.startsWith('GALERIE') &&
          entry['gebaeude'] !== undefined &&
          hasGallery(entry['gebaeude'])
        ">

          <img *ngIf="getMainGalleryImage(entry['gebaeude']) != null"
            class="mat-column-cell-gallery-height ktbl-clickable" [src]="getMainGalleryImage(entry['gebaeude'])"
            alt="Fehlendes Bild" (click)="openGallery(entry['gebaeude'])" />

        </ng-container>

        <!-- Pläne -->
        <ng-container *ngIf="
          column.startsWith('PLAENE') &&
          entry['gebaeude'] !== undefined &&
          hasGebaeudePDfs(entry['gebaeude'])
        ">

          <i (click)="onOpenPdf(entry['gebaeude'])" class="fas fa-file-pdf ktbl-icon-dark"
            matTooltip="Öffne Plan in separatem Tab" [matTooltipPosition]="position.value"
            [matTooltipClass]="position.value">
          </i>

        </ng-container>

      </td>

    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColsSelectGebaeude">
    </tr>

    <tr mat-row *matRowDef="let row; columns: displayedColsSelectGebaeude">
    </tr>

  </table>

  <mat-card>
    <div class="row">
      <div class="col-md-2">Preisstand {{ this.localService.selectedPreisstand.value.preisstand }}</div>
      <div class="col-md-6">
        Preisfaktor {{ this.localService.preisfaktor.value | number : "1.2-2" : "de-DE" }}
      </div>
    </div>

    <div *ngIf="hasUnselectedKge">
      <p></p>

      <p>Folgende Kostenelemente sind in der Berechnung nicht berücksichtigt:</p>
      <p *ngFor="let entry of unselectedKgeLabels">
        <li>{{ entry }}</li>
      </p>
    </div>

  </mat-card>
  <mat-accordion class="ktbl-example-headers-align" multi>


    <mat-expansion-panel [expanded]="true" hideToggle="true" #panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <i class="fas fa-chart-column ktbl-icon-mat-expansion"></i>

          <span class="ktbl-expansion-panel-padding">
            Investitionsbedarf, Kosten und Flächen
          </span>


          <div style="margin-left: auto;">
            <i *ngIf="!panel.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="ktbl-spacer-top-bottom"></div>
      <p>Investitionsbedarf und Kosten ohne Mehrwertsteuer.</p>
      <p *ngIf="
        !this.localService.istGebaeude.value
      ">
        Die Lagerung von Wirtschaftsdünger außerhalb des Stalles ist nicht
        berücksichtigt.
      </p>

      <div class="component-table-grid">
        <app-chart-inv-bed-kb [isPro]="false"></app-chart-inv-bed-kb>
        <app-chart-inv-bed-kb [isPro]="true"></app-chart-inv-bed-kb>

        <ng-container *ngIf="
                !this.localService.istGebaeude.value
              ">
          <app-chart-inv-bed-kb-je-m-quadrat-fkt></app-chart-inv-bed-kb-je-m-quadrat-fkt>


          <app-chart-fb-je-tp [isNetto]="false"></app-chart-fb-je-tp>
          <app-chart-fb-je-tp [isNetto]="true"></app-chart-fb-je-tp>

        </ng-container>

        <app-chart-inv-bed-nd></app-chart-inv-bed-nd>

        <app-chart-jaehrliche-gebeude-kosten [isPro]="false"></app-chart-jaehrliche-gebeude-kosten>

        <app-chart-jaehrliche-gebeude-kosten [isPro]="true"></app-chart-jaehrliche-gebeude-kosten>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" hideToggle="true" #panel2>
      <mat-expansion-panel-header>
        <mat-panel-title class="ktbl-mat-expension-panel-title">
          <i class="fas fa-table-list ktbl-icon-mat-expansion"></i>

          <span class="ktbl-expansion-panel-padding">
            Gebäudebeschreibung
          </span>

          <div style="margin-left: auto;">
            <i *ngIf="!panel2.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel2.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="ktbl-table-padding-top ktbl-scrollable">
        <table mat-table [dataSource]="dataSourceErgebnisAuspraegungGebaeude" class="ktbl-table-breite-komplett">

          <ng-container *ngFor="let column of displayedColsAuspraegungGebaeude; let j = index" [matColumnDef]="column">

            <th mat-header-cell *matHeaderCellDef [ngClass]="{
    'ktbl-gebaeudebeschreibung-width': j === 0,
    'ktbl-table-header-base-links': j === 0,
    'ktbl-table-header-base-rechts': j === (displayedColsAuspraegungGebaeude.length - 1),
    'ktbl-table-header-base-neutral': j !== 0 && j !== (displayedColsAuspraegungGebaeude.length - 1),
    'ktbl-table-header-typografie': true,
    'ktbl-gebaeudebeschreibung-gebaeude-width': j !== 0
  }">

              <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length === 1 && j !== 0">
                {{ ergebnisse.ergebnisGebaeudeList[j - 1].gebaeude.bezeichnung }}
              </ng-container>

              <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length !== 1 && j !== 0">
                {{ ergebnisse.ergebnisGebaeudeList[j].gebaeude.bezeichnung }}
              </ng-container>

            </th>

            <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
    'ktbl-table-content-normal': i % 2 === 0 && !entry.isUeberschrift,
    'ktbl-table-content-invert': i % 2 !== 0 && !entry.isUeberschrift,
    'ktbl-table-content-border': j === 0,
    'ktbl-table-cell-center': column.startsWith('AUSGABE'),
    'ktbl-typografie-reg-14-zwischenueberschrift': entry.isUeberschrift,
    'ktbl-table-zwischen-ueberschrift': entry.isUeberschrift
  }">

              <ng-container *ngIf="column.startsWith('MODUL')">
                {{
                entry.modul === undefined
                ? entry.modulbereich
                : entry.modul
                }}
              </ng-container>

              <ng-container *ngIf="column.startsWith('AUSGABE')">
                {{ entry.auspraegung[j - 1] }}
              </ng-container>

            </td>

          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsAuspraegungGebaeude"> </tr>

          <tr mat-row *matRowDef="let row; columns: displayedColsAuspraegungGebaeude"> </tr>

        </table>
      </div>
    </mat-expansion-panel>

    <ng-container *ngIf="
            !localService.istGebaeude.value
          ">

      <mat-expansion-panel [expanded]="true" hideToggle="true" #panel3>
        <mat-expansion-panel-header>
          <mat-panel-title class="ktbl-mat-expension-panel-title">
            <i class="fas fa-table-list ktbl-icon-mat-expansion"></i>
            <span class="ktbl-expansion-panel-padding">
              Tierplätze
            </span>
            <div style="margin-left: auto;">
              <i *ngIf="!panel3.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
              <i *ngIf="panel3.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
            </div>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="ktbl-table-padding-top ktbl-scrollable">

          <table mat-table [dataSource]="dataSourceErgebnisTierplaetze" class="ktbl-table-breite-komplett">

            <ng-container *ngFor="let column of displayedColsTierplaetze; let j = index" [matColumnDef]="column">

              <th mat-header-cell *matHeaderCellDef [ngClass]="{
    'ktbl-gebaeudebeschreibung-width': j === 0,
    'ktbl-table-header-base-links': j === 0,
    'ktbl-table-header-base-rechts': j === (displayedColsTierplaetze.length - 1),
    'ktbl-table-header-base-neutral': j !== 0 && j !== (displayedColsTierplaetze.length - 1),
    'ktbl-table-header-typografie': true,
    'ktbl-gebaeudebeschreibung-gebaeude-width': j !== 0
  }">

                <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length === 1 && j !== 0">
                  {{
                  ergebnisse.ergebnisGebaeudeList[j - 1].gebaeude.bezeichnung
                  }}
                </ng-container>

                <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length !== 1 && j !== 0">
                  {{
                  ergebnisse.ergebnisGebaeudeList[j].gebaeude.bezeichnung
                  }}
                </ng-container>

              </th>

              <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
    'ktbl-table-content-normal': i % 2 === 0,
    'ktbl-table-content-invert': i % 2 !== 0,
    'ktbl-table-content-border': j === 0,
    'ktbl-table-cell-center': column.startsWith('AUSGABE')
  }">

                <ng-container *ngIf="column.startsWith('MODUL')">

                  {{ entry.modul }}

                  <ng-container *ngIf="entry.information != null && entry.information != undefined">
                    <i class="fas fa-info-circle ml-1 ktbl-icon-info multiline-tooltip"
                      matTooltipClass="tooltip-format tooltip-format-line-break" [matTooltip]="entry.information">
                    </i>
                  </ng-container>

                </ng-container>

                <ng-container *ngIf="column.startsWith('AUSGABE')">
                  {{ entry.wert[j - 1] | number : "1.0-0" : "de-DE" }}
                </ng-container>

              </td>

            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColsTierplaetze"> </tr>

            <tr mat-row *matRowDef="let row; columns: displayedColsTierplaetze"> </tr>

          </table>
        </div>
      </mat-expansion-panel>
    </ng-container>

    <mat-expansion-panel [expanded]="true" hideToggle="true" #panel4>
      <mat-expansion-panel-header>
        <mat-panel-title class="ktbl-mat-expension-panel-title">
          <i class="fas fa-table-list ktbl-icon-mat-expansion"></i>

          <span class="ktbl-expansion-panel-padding">
            Flächen und Volumen
          </span>

          <div style="margin-left: auto;">

            <i *ngIf="!panel4.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel4.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>

        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="ktbl-table-padding-top ktbl-scrollable">

        <table mat-table [dataSource]="dataSourceErgebnisFlaechenVolumen" class="ktbl-table-breite-komplett">

          <ng-container *ngFor="let column of displayedColsFlaechenVolumen; let j = index" [matColumnDef]="column">

            <th mat-header-cell *matHeaderCellDef [ngClass]="{
    'ktbl-gebaeudebeschreibung-width': j === 0,
    'ktbl-table-header-base-links': j === 0,
    'ktbl-table-header-base-rechts': j === (displayedColsFlaechenVolumen.length - 1),
    'ktbl-table-header-base-neutral': j !== 0 && j !== (displayedColsFlaechenVolumen.length - 1),
    'ktbl-table-header-typografie': true,
    'ktbl-gebaeudebeschreibung-gebaeude-width': j !== 0
  }">

              <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length === 1 && j !== 0">
                {{
                ergebnisse.ergebnisGebaeudeList[j - 1].gebaeude.bezeichnung
                }}
              </ng-container>

              <ng-container *ngIf="ergebnisse.ergebnisGebaeudeList.length !== 1 && j !== 0">
                {{
                ergebnisse.ergebnisGebaeudeList[j].gebaeude.bezeichnung
                }}
              </ng-container>

            </th>

            <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
    'ktbl-table-content-normal': i % 2 === 0,
    'ktbl-table-content-invert': i % 2 !== 0,
    'ktbl-table-content-border': j === 0,
    'ktbl-table-cell-right': column.startsWith('AUSGABE')
  }">

              <ng-container *ngIf="column.startsWith('MODUL')">

                {{ entry.modul }}

                <ng-container *ngIf="entry.information != null && entry.information != undefined">
                  <i class="fas fa-info-circle ml-1 ktbl-icon-info multiline-tooltip"
                    matTooltipClass="tooltip-format tooltip-format-line-break" [matTooltip]="entry.information">
                  </i>
                </ng-container>

              </ng-container>

              <ng-container *ngIf="column.startsWith('AUSGABE')">
                {{ entry.wert[j - 1] }}
              </ng-container>

            </td>

          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsFlaechenVolumen"> </tr>

          <tr mat-row *matRowDef="let row; columns: displayedColsFlaechenVolumen"> </tr>

        </table>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" hideToggle="true" #panel5>
      <mat-expansion-panel-header>
        <mat-panel-title class="ktbl-mat-expension-panel-title">
          <i class="fas fa-table-list ktbl-icon-mat-expansion"></i>

          <span class="ktbl-expansion-panel-padding">
            Investitionsbedarf nach Kostenelementen
          </span>
          <div style="margin-left: auto;">
            <i *ngIf="!panel5.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel5.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>
          </div>

        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="ktbl-table-padding-top ktbl-scrollable">
        <table mat-table [dataSource]="dataSourceErgebnisInvBedKe" class="ktbl-table-breite-komplett">

          <ng-container *ngFor="let column of displayedColsErgebnisInvBedKe; let j = index" [matColumnDef]="column">

            <th mat-header-cell *matHeaderCellDef [ngClass]="{
        'ktbl-gebaeudebeschreibung-width': j === 0,
        'ktbl-table-header-base-links': j === 0,
        'ktbl-table-header-base-rechts': j === (displayedColsErgebnisInvBedKe.length - 1),
        'ktbl-table-header-base-neutral': j !== 0 && j !== (displayedColsErgebnisInvBedKe.length - 1),
        'ktbl-table-header-typografie': true,
        'ktbl-gebaeudebeschreibung-gebaeude-width': j !== 0
      }">

              <ng-container>
                {{
                j === 0
                ? "Kostengliederung nach DIN 276"
                : (
                ergebnisse.ergebnisGebaeudeList.length > 1
                ? ergebnisse.ergebnisGebaeudeList[j]?.gebaeude?.bezeichnung
                : ergebnisse.ergebnisGebaeudeList[j - 1]?.gebaeude?.bezeichnung
                )
                }}
              </ng-container>

            </th>

            <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
        'ktbl-table-cell-right': column.startsWith('GESAMTPREIS_'),
        'ktbl-table-summe-gesamt': entry.isUeberschrift && entry.isSumme,
        'ktbl-table-column-ueberschrift':
          entry.isUeberschrift &&
          !column.startsWith('GESAMTPREIS_') &&
          entry.isSumme,
        'ktbl-table-content-normal':
          ((i % 2 === 0) && !entry.isUeberschrift) ||
          (entry.isUeberschrift && entry.isSumme),
        'ktbl-table-content-invert':
          (i % 2 !== 0) && !entry.isUeberschrift,
        'ktbl-table-content-border': j === 0,
        'ktbl-typografie-reg-14-zwischenueberschrift':
          entry.isUeberschrift && !entry.isSumme,
        'ktbl-table-zwischen-ueberschrift':
          entry.isUeberschrift && !entry.isSumme
      }">

              <ng-container *ngIf="column.startsWith('KGE_BEZEICHNUNG')">
                {{ entry.kge }}
                <span *ngIf="entry.bezeichnung">
                  - {{ entry.bezeichnung }}
                </span>
              </ng-container>

              <ng-container *ngIf="column.startsWith('GESAMTPREIS_')">

                <span *ngIf="entry.gesamtPreis[j - 1] && entry.gesamtPreis[j - 1] > 0">
                  {{
                  entry.gesamtPreis[j - 1]
                  | number : "1.0-0" : "de-DE"
                  }}
                  €
                </span>

              </ng-container>

            </td>

          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsErgebnisInvBedKe">
          </tr>

          <tr mat-row *matRowDef="let row; columns: displayedColsErgebnisInvBedKe">
          </tr>

        </table>
      </div>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="true" hideToggle="true" #panel6>
      <mat-expansion-panel-header>
        <mat-panel-title>

          <i class="fas fa-table-list ktbl-icon-mat-expansion"></i>

          <span class="ktbl-expansion-panel-padding">
            Investitionsbedarf nach Kostenblöcken
          </span>


          <div style="margin-left: auto;">
            <i *ngIf="!panel6.expanded" class="fa-solid fa-circle-caret-down ktbl-icon-mat-expansion"></i>
            <i *ngIf="panel6.expanded" class="fa-solid fa-circle-caret-up ktbl-icon-mat-expansion"></i>

          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div class="ktbl-table-padding-top ktbl-scrollable">

        <table mat-table [dataSource]="dataSourceErgebnisInvBedKb" class="ktbl-table-breite-komplett">

          <!-- Erste Headerzeile -->

          <ng-container *ngFor="let column of displayedColsErgebnisInvBedKbHeader; let j = index"
            [matColumnDef]="column">

            <th mat-header-cell *matHeaderCellDef [ngClass]="{
    'ktbl-table-header-base-links': j === 0,
    'ktbl-gebaeudebeschreibung-width': j === 0,
    'ktbl-table-header-base-neutral': j !== 0 && j !== (displayedColsErgebnisInvBedKbHeader.length - 1),
    'ktbl-table-header-base-rechts': j === (displayedColsErgebnisInvBedKbHeader.length - 1),
    'ktbl-table-header-typografie': true
  }" [attr.colspan]="j === 0 ? null : 2">

              {{
              ergebnisse.ergebnisGebaeudeList.length === 1
              ? (
              j === 0
              ? ""
              : ergebnisse.ergebnisGebaeudeList[0].gebaeude.bezeichnung
              )
              : ergebnisse.ergebnisGebaeudeList[j].gebaeude.bezeichnung
              }}

            </th>

          </ng-container>

          <!-- Zweite Headerzeile + Datenzellen -->

          <ng-container *ngFor="let column of displayedColsErgebnisInvBedKb; let j = index" [matColumnDef]="column">

            <th mat-header-cell *matHeaderCellDef [ngClass]="{
              'ktbl-table-header-base-second': true,
              'ktbl-table-header-typografie': true,
              'ktbl-gebaeudebeschreibung-gebaeude-sub-width': j > 0
            }">

              <ng-container *ngIf="column.startsWith('GESAMT_')">
                gesamt
              </ng-container>

              <ng-container *ngIf="column.startsWith('JE_TIERPLATZ_')">

                <ng-container *ngIf="!localService.istGebaeude.value">
                  je Tierplatz
                </ng-container>

                <ng-container *ngIf="localService.istGebaeude.value">
                  je m³
                </ng-container>

              </ng-container>

            </th>

            <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
    'ktbl-table-content-normal': !(!entry.isSumme && entry.isUeberschrift),
    'ktbl-table-content-border': j === 0,
    'ktbl-typografie-reg-14-zwischenueberschrift': !entry.isSumme && entry.isUeberschrift,
    'ktbl-table-zwischen-ueberschrift': !entry.isSumme && entry.isUeberschrift,
    'ktbl-table-summe': entry.isSumme && !entry.isUeberschrift,
    'ktbl-table-summe-gesamt': entry.isSumme && entry.isUeberschrift,
    'ktbl-table-cell-right': column.startsWith('GESAMT_') || column.startsWith('JE_TIERPLATZ_')
  }">

              <ng-container *ngIf="column.startsWith('KOSTENBLOCK')">

                <span [ngClass]="{
        'ktbl-table-column-ueberschrift': entry.isSumme
      }">
                  {{ entry.bezeichnung }}
                </span>

              </ng-container>

              <ng-container *ngIf="
      entry.gesamtAnzahlKomma.length !== 0 &&
      column.startsWith('GESAMT_')
    ">

                {{
                entry.gesamt[adjustIndexKb(j)]
                | number
                : "1." +
                entry.gesamtAnzahlKomma[adjustIndexKb(j)] +
                "-" +
                entry.gesamtAnzahlKomma[adjustIndexKb(j)]
                : "de"
                }}
                &euro;

              </ng-container>

              <ng-container *ngIf="
      entry.jeTierplatzAnzahlKomma.length !== 0 &&
      column.startsWith('JE_TIERPLATZ_')
    ">

                {{
                entry.jeTierplatz[adjustIndexKb(j)]
                | number
                : "1." +
                entry.jeTierplatzAnzahlKomma[adjustIndexKb(j)] +
                "-" +
                entry.jeTierplatzAnzahlKomma[adjustIndexKb(j)]
                : "de"
                }}
                &euro;

              </ng-container>

            </td>

          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColsErgebnisInvBedKbHeader"> </tr>

          <tr mat-header-row *matHeaderRowDef="displayedColsErgebnisInvBedKb"> </tr>

          <tr mat-row *matRowDef="let row; columns: displayedColsErgebnisInvBedKb"> </tr>

        </table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</span>
<div class="ktbl-spacer-top-bottom"></div>

<div class="ktbl-button-container">
  <div class="ktbl-button-container-left">
    <button (click)="this.localService.mainComponentRef.value!.onClickZurAuswahl()"
      class="ktbl-button-primaer ktbl-button-width-m" type="button">
      <i class="fas fa-arrow-left ktbl-icon-vertical-align"></i>

      Zurück
    </button>
  </div>

  <div class="ktbl-button-container-right" *ngIf="this.localService.selectedGebaeudeList.value.length !== 0">

    <button (click)="onClickDownloadExcel()" class="ktbl-button-sekundaer ktbl-button-width-m" type="button"
      matTooltip="Als Excel" [matTooltipPosition]="position.value" [matTooltipClass]="position.value">
      <i class="fas fa-download ktbl-icon-vertical-align"></i>


      Export
    </button>
  </div>
</div>